module.exports = "<my-title my-label=\"$root.labels.sale.titles.create\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"3\">\n</my-title>\n\n<my-sale-create-form my-sale=\"$$sale.data.mySale\"\n  my-searched-wagons=\"$$sale.data.mySearchedWagons\"\n  my-area-searchdata=\"$$area.data.myAreaSearchdata\"\n  my-railway-searchdata=\"$$railway.data.myRailwaySearchdata\">\n</my-sale-create-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/scrapping/sale/templates/new.html
// module id = 1619
// module chunks = 0